import React, { FC } from "react";
import { IonIcon, IonLabel } from "@ionic/react";

import checkIcon from "../../../assets/images/PulseSurvey/check_icon.svg";
import closeIcon from "../../../assets/icons/close_no_circle.svg";
import Portal from "../../../atoms/Portal";

import styles from "./Complete.module.scss";

export type Props = {
  isOpen: boolean;
  closeModal: () => void;
};

const Complete: FC<Props> = ({ isOpen, closeModal }) => {
  return isOpen ? (
    <Portal>
      <div className={`${styles.modal}`}>
        <div className={`${styles.backdrop}`} />
        <div className={styles.slide}>
          <div className={styles.item}>
            <button className={styles.item__button_close} onClick={closeModal}>
              <IonIcon
                icon={closeIcon}
                slot="start"
                className={styles.item__icon_close}
              />
            </button>
          </div>
          <div className={styles.wrapper}>
            <div className={styles.circleWrapper}>
              <p className={styles.count}>
                <IonIcon
                  icon={checkIcon}
                  slot="start"
                  className={styles.item__icon_complete}
                />
              </p>
            </div>
            <div className={styles.question}>
              <IonLabel className={styles.question__label}>
                今日もお疲れ様でした！
              </IonLabel>
            </div>
            <div className={styles.description}>
              <IonLabel>
                記録して気づいたことがあれば
                <br className={styles.isSp} />
                ストックしておこう。
              </IonLabel>
            </div>
            <div className={styles.actions}>
              <button
                className={styles.actions__button}
                onClick={() => closeModal()}
              >
                閉じる
              </button>
            </div>
          </div>
        </div>
      </div>
    </Portal>
  ) : null;
};

export default Complete;
